import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ChangePasswordModule} from './change-password/change-password.module';
import {CoreModule} from './core/core.module';
import {LoginModule} from './login/login.module';
import {MainModule} from './main/main.module';
import {ThemeModule} from './theme/theme.module';
import {PasswordExpiryPopupComponent} from './password-expiry-popup/password-expiry-popup.component';
import {PasswordExpiryEmitter} from './password-expiry-popup/services/password-expiry-emitter.service';
import {PasswordExpiry} from './password-expiry-popup/services/password-expiry.service';
import {DeviceDetectorModule} from 'ngx-device-detector';
import {NbDatepickerModule} from '@nebular/theme';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {CsvErrorsService} from './shared/facades/csv-errors.service';
import {TranslateModule} from '@ngx-translate/core';
import {JoincallModule} from './joincall/joincall.module';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { PatientFacadeService } from './main/patients/patients-facade.service';
import { PatientDataFacadeService } from './main/data-upload/patient-data-facade.service';

@NgModule({
  declarations: [AppComponent, PasswordExpiryPopupComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CoreModule,
    LoginModule,
    ChangePasswordModule,
    ThemeModule.forRoot(),
    MainModule,
    NbEvaIconsModule,
    DeviceDetectorModule,
    NbDatepickerModule.forRoot(),
    NgxChartsModule,
    TranslateModule,
    JoincallModule,
    CalendarModule
  ],
  providers: [PasswordExpiryEmitter, PasswordExpiry, CsvErrorsService, PatientFacadeService, PatientDataFacadeService],
  bootstrap: [AppComponent],
})
export class AppModule {}
